import React from 'react'
import { endpoint } from '../../../../../manage/common/constant';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { templateUrl } from 'views/pages/manage/common/constant/endpoints/documentService';
import { bulkPayModeUploadDropdown, getPaymentModeAndProcessIdMapping, payModeProcessTagTypeMapping, serviceNameMapping } from './constant';
export const searchHandlerlisting = async (req = {}, page = 0) => {
    const res = await fetchAllPostPromisedData(`${endpoint.bulkCollection.get}?offset=${page}`, req)
    if (res?.code == 200) {
        return res?.data;
    }

}

export const getBulkUploadDetailsByPid = async (pid) => {
    return await fetchAllPromisedData(`${endpoint.bulkCollection.getBulkUploadDetailsByPid}?pid=${pid}`)
}

export const downLoadFile = async (s3Key) => {
    const templateUrl = await fetchAllPostPromisedData(`${endpoint.fetchS3Url.getDownloadUrl}?key=${s3Key}`, {})
    if (templateUrl?.code === 200 && templateUrl?.data) {

        window.open(`${templateUrl?.data?.url}`)
    }
    else {
        failureToast("Something went wrong please try after sometime.")
    }
};

export const getDownloadTemplateUrl = async (item) => {

    return await fetchAllPromisedData(`${templateUrl}?documentTypeDisplayValue=${serviceNameMapping?.[item?.value]}&serviceType=${serviceNameMapping?.[item?.value]}`)
}
export const getAllActivePaymentMode = async (roleId) => {
    const url = `${endpoint?.paymentMode?.getActive}?requireMapping=${1}`;
    try {
        const res = await Promise.all([fetchAllPromisedData(url), fetchAllPromisedData(endpoint.process_Tag.getAllActive)]);
        const payModeList = res[0];
        const processTagList = res[1];
        const l = bulkPayModeUploadDropdown?.map(item => item?.value)
        const bulkActiveList = payModeList?.filter(item => {
            if (l.includes(item?.paymentModeKey)) {
                return item
            }
        })
        let payModeProcessIdMapping = {}
        payModeProcessTagTypeMapping.forEach((item) => {
            const mapObj = getPaymentModeAndProcessIdMapping(item, processTagList)
            payModeProcessIdMapping = { ...payModeProcessIdMapping, [item?.payMode]: mapObj?.id }
        })
        const accessibleList = bulkActiveList?.filter(item => {
            return (item.paymentModeProcessTagTypeMappingDTOS ?? []).some(p => {
                if (payModeProcessIdMapping?.[item?.paymentModeKey] === p.processTagTypeMasterId && (p.status).toUpperCase() === 'ACTIVE') {
                    return p.processTagTypeRoleMappingDTOS.some(r => roleId.includes(r?.roleId));
                }
                return false;
            });
        });
        return {accessibleList:[...accessibleList.map((item) => ({
            label: item?.paymentModeKey,
            value: item?.id,
        }))
        ,{label:'EXAM',value:'EXAM'}
    ],
        payModeProcessIdMapping
    };

    } catch (error) {
        console.log(error);
    }
};

